import { mins } from "@/lib/myVoicesApi";

const verdict = (s, st) => (s >= st.great_sec ? ["Great amount", "text-emerald-300"] : s >= st.good_sec ? ["Good amount", "text-cyan-200"]
  : s >= st.min_sec ? ["Enough for a quick test", "text-amber-200"] : ["Add more singing", "text-rose-200"]);

/** Minutes of clean singing vs the 2 / 10 / 30-minute marks. */
export default function TrainingMeter({ seconds, status }) {
  const st = { min_sec: 120, good_sec: 600, great_sec: 1800, ...status };
  const pct = Math.min(100, (seconds / st.great_sec) * 100);
  const [label, cls] = verdict(seconds, st);
  const marks = [[st.min_sec, "2 min"], [st.good_sec, "10 min"], [st.great_sec, "30 min"]];
  return (
    <div data-testid="training-meter">
      <div className="flex items-baseline justify-between">
        <span className="font-display text-2xl font-semibold tabular-nums" data-testid="training-meter-minutes">{mins(seconds)}</span>
        <span className={`text-[12px] font-medium ${cls}`} data-testid="training-meter-verdict">{label}</span>
      </div>
      <div className="relative mt-3 h-2.5 rounded-full bg-white/10">
        <div className="h-full rounded-full bg-gradient-to-r from-cyan-400 to-emerald-300 transition-[width] duration-700" style={{ width: `${pct}%` }} />
        {marks.map(([s, l], i) => (
          <span key={l} className={`absolute top-full mt-1.5 whitespace-nowrap font-mono text-[9px] uppercase tracking-[0.12em] text-white/40 ${i === marks.length - 1 ? "-translate-x-full" : "-translate-x-1/2"}`} style={{ left: `${(s / st.great_sec) * 100}%` }}>
            <span className={`absolute -top-[18px] h-2.5 w-px bg-white/30 ${i === marks.length - 1 ? "right-0" : "left-1/2 -translate-x-1/2"}`} />{l}
          </span>
        ))}
      </div>
      <p className="mt-7 text-[12px] leading-relaxed text-white/50">Clean singing only (silences removed). 10–30 minutes of you singing a cappella — different songs, high and low notes, soft and strong — gives the most natural model.</p>
    </div>
  );
}
